import { useQuery } from '@tanstack/react-query';

import { ensureSettings } from '../../../adapter/stories-hasura-service/api';
import { ISettings } from '../../../../types';
import { processEntitySettings } from '../../../transformations/settingsTransformation';
import { storiesSettingsQueryKeys } from './storiesSettingsQueryKeys';

export type UseFetchSettingsOptions = {
  entityId: number;
};

export function useFetchSettings({ entityId }: UseFetchSettingsOptions) {
  return useQuery<ISettings>({
    queryKey: storiesSettingsQueryKeys.settings(entityId),
    queryFn: async () => {
      const response = await ensureSettings(entityId);
      return processEntitySettings(response);
    },
    enabled: !!entityId
  });
}
